const browsers: Array<[RegExp, string]> = [
  [/Edg(e|A|iOS)?\//, 'Edge'],
  [/OPR\/|Opera/, 'Opera'],
  [/Firefox\/|FxiOS\//, 'Firefox'],
  [/Chrome\/|CriOS\//, 'Chrome'],
  [/Safari\//, 'Safari'],
];

const systems: Array<[RegExp, string]> = [
  [/iPhone/, 'iPhone'],
  [/iPad/, 'iPad'],
  [/Android/, 'Android'],
  [/Windows/, 'Windows'],
  [/Mac OS X|Macintosh/, 'macOS'],
  [/CrOS/, 'ChromeOS'],
  [/Linux/, 'Linux'],
];

/**
 * "Chrome · Windows" from a User-Agent header, for lists of signed-in
 * browsers. Order matters: Edge and Opera also say Chrome, Chrome also says
 * Safari, iOS also says Mac OS X, Android also says Linux.
 */
export function describeUserAgent(ua: string): string {
  const browser = browsers.find(([re]) => re.test(ua))?.[1];
  const system = systems.find(([re]) => re.test(ua))?.[1];
  if (!browser && !system) return 'Unknown browser';
  return [browser ?? 'Browser', system].filter(Boolean).join(' · ');
}
